// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"b7f075dc","453":"349cea75"}[chunkId] + ".chunk.js";
};